/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';

/**
 * PageName: LEISURE_HOME    */
export const LeisureHomePageLog = {
  QuickCategoryBoardRowItem: {
    /**
     * 레져 서브홈 - 퀵카테고리 - 노출
     * 참고: https://screen.yanolja.in/5Ds8OLH4a83YGNrH
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/leisure/common.txtpb#L4}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    impression({ widgetPosition, position, logMeta }: LeisureHomePageLog.QuickCategoryBoardRowItem.Impression) {
      return KinesisTracker.impression('LEISURE_HOME', {
        clientEventId: 313,
        pageName: 'PAGE_NAME_LEISURE_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        widgetPosition,
        position,
        ...logMeta,
      });
    },

    /**
     * 레져 서브홈 - 퀵카테고리 - 클릭
     * 참고: https://screen.yanolja.in/5Ds8OLH4a83YGNrH
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/leisure/common.txtpb#L17}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    click({ widgetPosition, position, logMeta }: LeisureHomePageLog.QuickCategoryBoardRowItem.Click) {
      return KinesisTracker.click('LEISURE_HOME', {
        clientEventId: 314,
        pageName: 'PAGE_NAME_LEISURE_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        widgetPosition,
        position,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace LeisureHomePageLog {
  export namespace QuickCategoryBoardRowItem {
    /**
     * 참고: https://screen.yanolja.in/5Ds8OLH4a83YGNrH
     */
    export interface Impression {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * 참고: https://screen.yanolja.in/5Ds8OLH4a83YGNrH
     */
    export interface Click {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}

/**
 * PageName: FAMILY_HOME
 */
export const FamilyHomePageLog = {
  QuickCategoryBoardRowItem: {
    /**
     * 레져 서브홈 - 아이야놀자 - 퀵카테고리 - 노출
     * 참고: https://screen.yanolja.in/HefvrFdXbIPoOEBW
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/leisure/common.txtpb#L30}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    impression({ widgetPosition, position, logMeta }: FamilyHomePageLog.QuickCategoryBoardRowItem.Impression) {
      return KinesisTracker.impression('FAMILY_HOME', {
        clientEventId: 315,
        pageName: 'PAGE_NAME_FAMILY_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        widgetPosition,
        position,
        ...logMeta,
      });
    },

    /**
     * 레져 서브홈 - 아이야놀자 -  퀵카테고리 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/leisure/common.txtpb#L43}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    click({ widgetPosition, position, logMeta }: FamilyHomePageLog.QuickCategoryBoardRowItem.Click) {
      return KinesisTracker.click('FAMILY_HOME', {
        clientEventId: 316,
        pageName: 'PAGE_NAME_FAMILY_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        widgetPosition,
        position,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace FamilyHomePageLog {
  export namespace QuickCategoryBoardRowItem {
    /**
     * 참고: https://screen.yanolja.in/HefvrFdXbIPoOEBW
     */
    export interface Impression {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}
